module.exports = __webpack_public_path__ + "img/briefcase1.9fd18519.svg";